import React from "react";
import { Link } from "react-router-dom";
import { ShoppingBag, CreditCard, Warehouse, Ship, ShieldCheck, Bike } from "lucide-react";

const STEPS = [
  { icon: ShoppingBag, title: "Browse & choose", desc: "Explore authentic UK products with fully transparent, all-inclusive prices shown in GH₵ and GBP." },
  { icon: CreditCard, title: "Order & pay securely", desc: "Pay once at checkout. Your price already includes the product, shipping and import handling." },
  { icon: Warehouse, title: "We buy & consolidate", desc: "We purchase from the UK store and gather your items at our UK warehouse." },
  { icon: Ship, title: "Shipped to Ghana", desc: "Your order is shipped via trusted freight partners to Ghana." },
  { icon: ShieldCheck, title: "Customs cleared", desc: "We handle all customs paperwork and clearance so you don't have to." },
  { icon: Bike, title: "Delivered to your door", desc: "Local riders hand-deliver in Accra, Tema and Kumasi." },
];

export default function HowItWorks() {
  return (
    <div className="max-w-6xl mx-auto px-5 sm:px-8 py-16">
      <p className="text-xs tracking-[0.2em] uppercase font-semibold text-[#306D29] mb-3">The AfriGate journey</p>
      <h1 className="font-display text-5xl sm:text-6xl font-light tracking-tight text-[#0D530E] max-w-3xl leading-[0.95]">
        We handle everything between the shelf and your door
      </h1>
      <p className="text-[#306D29]/80 text-lg font-light mt-6 max-w-2xl">
        No international cards, no shipping headaches, no customs stress. You order — we do the rest.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-14">
        {STEPS.map((s, i) => (
          <div key={s.title} className="flex gap-5 rounded-3xl bg-[#E7E1B1]/30 border border-[#0D530E]/5 p-8">
            <div className="shrink-0">
              <div className="w-12 h-12 rounded-full bg-[#306D29] text-[#FBF5DD] flex items-center justify-center"><s.icon size={22} /></div>
            </div>
            <div>
              <p className="font-display text-3xl text-[#306D29]/25 leading-none mb-1">0{i + 1}</p>
              <h3 className="font-display text-2xl text-[#0D530E]">{s.title}</h3>
              <p className="text-[#306D29]/80 font-light mt-1 leading-relaxed">{s.desc}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="rounded-[32px] bg-[#0D530E] text-[#FBF5DD] p-12 mt-16 text-center">
        <h2 className="font-display text-4xl font-light">Ready to shop the UK?</h2>
        <p className="text-[#FBF5DD]/75 font-light mt-3">Authentic products, transparent prices, delivered across Ghana.</p>
        <Link to="/shop" className="inline-flex bg-[#E7E1B1] hover:bg-[#FBF5DD] text-[#0D530E] font-medium px-8 py-4 rounded-full mt-8" style={{ transition: "background-color 0.2s ease" }}>
          Start shopping
        </Link>
      </div>
    </div>
  );
}
